import CUSTOM_WIDGETS_REGISTRY from "@/modules/dashboard/customizing/CUSTOM_WIDGETS_REGISTRY";
import cloneDeep from 'lodash/cloneDeep';

var valid = false; //resets to 'false' on page refresh, in particular on language change
var tree = [];

export const generateModules = (modules) => {
    return {
        get tree() {
            if (valid) {
                return tree;
            }
            else {
                tree = modules;
                valid = true;
                return tree;
            }
        },
        get moduleWidgets() {
            let clonedTree = cloneDeep(tree);

            for (let customWidget of CUSTOM_WIDGETS_REGISTRY) {
                let indexOfModule = clonedTree.findIndex((module) => module.id === customWidget.moduleId);

                let children = cloneDeep(customWidget.children).map((child) => ({ ...child, neverHide: true }));
                clonedTree[indexOfModule].children.push(...children);
            }

            return clonedTree;
        }
    }
}
